import React from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
    const location = useLocation();
    const pathname = location.pathname + location.hash; // handles #services

    const isActive = (path) => pathname === path;

    const handleServicesClick = (e) => {
        // Check if we're already on the home page
        if (location.pathname === '/' || location.pathname === '/index' || location.pathname === '/home') {
            e.preventDefault();
            const servicesSection = document.getElementById('services');
            if (servicesSection) {
                servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        // Otherwise, let the default navigation happen to /index#services
    };

    return(
        <header id="header" class="fixed-top">
            <div class="container d-flex align-items-center">
                <h1 class="logo me-auto">
                    <a href="/index"><img alt="logo" src="/logo/logo.png" /><span>KPA</span>Structure</a>
                </h1>
                <a href="/index" class="logo me-auto me-lg-0">
                    <img src="/assets/images/logo.png" alt="" class="img-fluid"/>
                </a>
                <nav id="navbar" className="navbar order-last order-lg-0">
                    <ul>
                        <li className={isActive("/index") ? "active" : ""}>
                            <a href="/index">Home</a>
                        </li>

                        <li className={`dropdown ${isActive("/about-us") ? "active" : ""}`}>
                            <a href="/about-us"><span>About Us</span></a>
                        </li>

                        <li className={pathname.includes("#services") ? "active" : ""}>
                            <a href="/index#services" onClick={handleServicesClick}>Services</a>
                        </li>

                        <li className={isActive("/portfolio") ? "active" : ""}>
                            <a href="/portfolio">Portfolio</a>
                        </li>

                        <li className={isActive("/contact") ? "active" : ""}>
                            <a href="/contact">Contact</a>
                        </li>
                    </ul>
                    <i class="bi bi-list mobile-nav-toggle"></i>
                </nav>
               

            </div>
        </header>
    )
};

export default Header;